import { IDeviceIdentificationObject } from './device-identification-object.interface';
import { IDeviceOutputDto } from './device-output-dto.interface';
import { IPlatformOutputDto } from './platform-output-dto.interface';

interface Coordinates {
    type: string; // "Point"
    coordinates: number[]; // [longitude, latitude]
}

interface DeviceOutputToPositionById extends IDeviceOutputDto {
    id: number;
    externalId: string;
    externalIdSource: string;
    organizationId: string;
    name: string;
    code: string;
    identification: IDeviceIdentificationObject;
    licensePlate: string | null;
    enabled: boolean;
    latitude: string;
    longitude: string;
    lastReport: string;
    lastPositionUpdate: string;
}

export interface IGetDevicePositionsByPositionIdOutputDto {
    id: number;
    device: DeviceOutputToPositionById;
    coordinates: Coordinates;
    heading: number;
    timestamp: string;
    insertedAt: string;
    speed: number;
    platform: IPlatformOutputDto;
    metadata?: Record<string, unknown>;
}
